export default __webpack_public_path__ + "static/media/empty.bd29e899.svg";